import { style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles";
import {
  NEWS_CONTAINER_BREAKPOINTS,
  newsContainer,
} from "../../styles/containers.css";

const listBase = style({
  display: "grid",
  gridTemplateColumns: "1fr",
  gap: vars.space.m,
});

export const newsScrollableRow = style({
  display: "flex",
  flexDirection: "row",
  gap: vars.space.m,
  overflowX: "auto",
  overflowY: "hidden",
});

export const newsGrid6fr = style([
  listBase,
  {
    "@container": {
      [`${newsContainer} (min-width: ${NEWS_CONTAINER_BREAKPOINTS[1]})`]: {
        gridTemplateRows: "auto",
        gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
      },
      [`${newsContainer} (min-width: ${NEWS_CONTAINER_BREAKPOINTS[2]})`]: {
        gridTemplateRows: "auto",
        gridTemplateColumns: "repeat(6, minmax(0, 1fr))",
      },
    },
  },
]);

export const newsGrid3fr = style([
  listBase,
  {
    "@container": {
      [`${newsContainer} (min-width: ${NEWS_CONTAINER_BREAKPOINTS[0]})`]: {
        gridTemplateRows: "auto",
        gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
      },
    },
  },
]);
